<script>
import safeSearch from "@/views/count/safe/safeSearch.vue";
export default {
  name: "DailySafe",
  components:{
    safeSearch
  },
  data() {
    return {
      tableData: [],
      jcxmList:[],
      tableTitle:'',
      czList:[],
      dataDate: '',
      currentDate: '',
      columns: [
        { label: '测压管水位', prop: 'dayRain',align:"right"},
        { label: '实际水深', prop: 'maxDhp',align:"right" },
        { label: '最大水位', prop: 'maxDhp2',align:"right" },
        { label: '最大水位时间', prop: 'maxDhp3',align:"right" },
        { label: '最小水位', prop: 'maxDhp4',align:"right" },
        { label: '最小水位时间', prop: 'maxDhp5',align:"right" },
      ],
      //测压管字段
      cygColumns:[
        { label: '日期', prop: 'dt',align:"center" },
        { label: '测压管水位(m)', prop: 'avPztbwl',align:"right" },
        { label: '温度(℃)', prop: 'wt',align:"right" },
        { label: '最高水位(m)', prop: 'mxPztbwl',align:"right" },
        { label: '最低水位(m)', prop: 'mnPztbwl',align:"right" },
        { label: '实际水深(m)', prop: 'rwater' ,align:"right"},

      ],
      //渗压字段
      syColumns:[
        { label: '日期', prop: 'dt',align:"center" },
        { label: '渗流压力水位(m)', prop: 'avSpprwl',align:"right" },
        { label: '温度(℃)', prop: 'wt',align:"right" },
        { label: '渗流压力最高水位(m)', prop: 'mxSpprwl',align:"right" },
        { label: '渗流压力最低水位(m)', prop: 'mnSpprwl',align:"right" },

      ],
      //应变字段
      ybColumns:[
        { label: '日期', prop: 'dt',align:"center" },
        { label: '应变(10^(-6))', prop: 'avStn',align:"right" },
        { label: '温度(℃)', prop: 'wt',align:"right" },
        { label: '最大应变(10^(-6))', prop: 'mxStn',align:"right" },
        { label: '最小应变(10^(-6))', prop: 'mnStn',align:"right" },

      ],
      //位移字段
      czColumns:[
        { label: '日期', prop: 'dt',align:"center",width:'120px' },
        { label: '垂直位移(mm)', prop: 'avVrds',align:"right"},
        { label: '最大垂直位移(mm)', prop: 'mxVrds',align:"right"},
          { label: '最大垂直位移时间', prop: 'mxMstm',align:"center"},
        { label: '最小垂直位移(mm)', prop: 'mnVrds',align:"right"},
        { label: '最小垂直位移时间', prop: 'mnMstm',align:"center"},
      ],

      //位移字段
      xxColumns:[
        { label: '日期', prop: 'dt',align:"center",width:'120px' },
        { label: 'X向位移(mm)', prop: 'avXhdrs',align:"right"},
        { label: '最大X向位移(mm)', prop: 'mxXhdrs',align:"right"},
        { label: '最大X向位移时间', prop: 'mxXmstm' ,width:'180px',align:"center"},
        { label: '最小X向位移(mm)', prop: 'mnXhdrs',align:"right"},
        { label: '最小X向位移时间', prop: 'mnXmstm',width:'180px',align:"center" },
      ],

      //位移字段
      yxColumns:[
        { label: '日期', prop: 'dt',align:"center",width:'120px' },
        { label: 'Y向位移(mm)', prop: 'avYhdrs',align:"right"},
        { label: '最大Y向位移(mm)', prop: 'mxYhdrs',align:"right"},
        { label: '最大Y向位移时间', prop: 'mxYmstm',width:'180px',align:"center" },
        { label: '最小Y向位移(mm)', prop: 'mnYhdrs',align:"right"},
        { label: '最小Y向位移时间', prop: 'mnYmstm',width:'180px',align:"center" },
      ],

    }
  },
  methods: {
    init() {
      this.query();
    },
    //获取监测项目list
    getJcxxList(){
      this.request.get('/rm-bmp/queryMstpListByRescd').then(res => {
        if (res.ok) {
          if (res.data != null) {
            this.jcxmList = res.data.mstps;
            if(res.data.mstps.length > 0 ){
              this.$store.state.search.jcxmId = this.jcxmList[0].mstp;
              this.$store.state.search.jcxm = this.jcxmList[0].mstpNm;
            }else{
              this.$store.state.search.jcxmId = '';
              this.$store.state.search.jcxm = '';
            }
            // let kiMap = new Map();
            // for (let i = 0; i < res.data.length; i++) {
            //   this.jcxmList.push({
            //     mstp: res.data[i]['code'],
            //     mstpName: res.data[i]['name'],
            //   });
            // }

            this.$nextTick(() => {
              this.getCzList(this.$store.state.search.jcxmId);
            });

          } else {
            this.$message.info("获取测点所属数据项数据为空");
          }
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    //获取监测项目list
    getCzList(mstp){
      if(mstp!=''){
        this.request.get('rm-bstmp/queryByMstp/'+mstp).then(res => {
          if (res.ok) {
            if (res.data != null) {
              this.czList = [];
              if(res.data.length > 0 ){
                for (let i = 0; i < res.data.length; i++) {
                  this.czList.push({
                    stcd: res.data[i]['k'],
                    stnm: res.data[i]['v'],
                  });
                }
                // this.czVal =  this.czList[0]
                this.$store.state.search.jcdId =  this.czList[0].stcd;
                this.$store.state.search.jcd =  this.czList[0].stcd;
              }else{
                this.$store.state.search.jcdId =  '';
                this.$store.state.search.jcd =  '';
              }

              this.init();
            } else {
              this.$message.info("获取测站数据为空");
            }
          } else {
            this.$message.error(res.error.message);
          }
        });
      }else{
        this.$store.state.search.jcdId =  '';
        this.$store.state.search.jcd =  '';
        this.tableData=[];
        this.tableTitle='';
        this.columns=[];
      }

    },
    tableRowClassName({row, rowIndex}) {
      return {
        Color:'white',
        height: '3vh',
      };
    },

    query() {
      const jcxmId= this.$store.state.search.jcxmId;
      const jcxm= this.$store.state.search.jcxm;
      const jcdId = this.$store.state.search.jcdId;
      const jcd= this.$store.state.search.jcd;
      const fastChoose = this.$store.state.search.fastChoose;
      const dateValue = this.$store.state.search.dateValue;
      const params = {
        queryDateType: "",
        dtGT: "",
        dtLE: "",
        mpcd:jcdId,
      };
      if (fastChoose !== "ZDY") {
        params.queryDateType = fastChoose;
      } else {
        params.dtGT = dateValue[0];
        params.dtLE = dateValue[1];
      }
      let requestUrl ='';
      this.tableTitle = jcxm + '-' +jcd +'安全报表';
     switch (jcxmId){
       case '0601':
          requestUrl ='/rm-report-security/v1/pzwl/report';
          this.tableTitle = '';
          this.columns = this.cygColumns;
          this.tableTitle = jcxm + '-' +jcd +'安全报表';
         break;
       case '0602':
          requestUrl ='/rm-report-security/v1/sppr/report';
          this.columns = this.syColumns;
         break;
       case '0603':
          requestUrl ='/rm-report-security/v1/st/report';
          this.columns = this.ybColumns;
         break;
       case '0604':
          requestUrl ='/rm-report-security/v1/srrdsx/report';
          this.columns = this.xxColumns;
         break;
       case '0605':
         requestUrl ='/rm-report-security/v1/srrdsy/report';
         this.columns = this.yxColumns;
         break;
       case '0606':
         requestUrl ='/rm-report-security/v1/srvrd/report';
         this.columns = this.czColumns;
         break;
       default:
          requestUrl ='/rm-report-security/v1/pzwl/report';
         this.tableTitle = jcxm + '-' +jcd +'安全报表';
         this.columns = this.cygColumns;
     }
      this.request.get(requestUrl,{params:params}).then(
          (res) => {
            if (res.ok) {
              //console.log('res',res);
              if(fastChoose ==='TODAY'||fastChoose ==='YESTERDAY'){
                this.tableTitle = res.data.dtstrGT+' '+jcd + '-' +jcxm;
              }else{
                this.tableTitle = res.data.dtstrGT+'至'+res.data.dtstrLE+' '+jcd + '-' +jcxm;
              }
              this.tableData = res.data.list;

            } else {
              this.$message({
                message: res.error.message,
                type: 'error',
                duration: 3000, //显示时间 <=0：永久显示,1000：1s
              });
            }
          }
      );
    },
    download() {
      const jcxmId= this.$store.state.search.jcxmId;
      const jcdId = this.$store.state.search.jcdId;
      const fastChoose = this.$store.state.search.fastChoose;
      const dateValue = this.$store.state.search.dateValue;
      const params = {
        queryDateType: "",
        dtGT: "",
        dtLE: "",
        mpcd:jcdId,
      };
      if (fastChoose !== "ZDY") {
        params.queryDateType = fastChoose;
      } else {
        params.dtGT = dateValue[0];
        params.dtLE = dateValue[1];
      }
      let requestUrl ='';
      switch (jcxmId) {
        case '0601':
          requestUrl = '/rm-report-security/v1/pzwl/export';
          break;
        case '0602':
          requestUrl = '/rm-report-security/v1/sppr/export';
          break;
        case '0603':
          requestUrl = '/rm-report-security/v1/st/export';
          break;
        case '0604':
          requestUrl = '/rm-report-security/v1/srrds/exportX';
          break;
        case '0605':
          requestUrl = '/rm-report-security/v1/srrdsy/exportY';
          break;
        case '0606':
          requestUrl = '/rm-report-security/v1/srvrd/export';
          break;
        default:
          requestUrl = '/rm-report-security/v1/pzwl/export';
      }
      this.request.get(requestUrl,{ params: params,responseType: "blob" }).then((res) => {
        try {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          // 这里填保存成的文件名
          a.download = decodeURI(res.headers["content-disposition"].split(";")[1].split("=")[1]);
          a.click();
          URL.revokeObjectURL(a.href);
          return;
        } catch (error) {
          const reader = new FileReader();
          reader.readAsText(res.data, 'utf-8');
          let _this = this;
          reader.onload=function(){
            const msg = JSON.parse(reader.result);
            if (!msg.ok) {
              if (msg.error.code === 3001) {
                _this.$message.error(msg.error.message);
              } else {
                _this.$message.warning(msg.error.message);
              }
            }
          }
        }
      });
    },
  },
  mounted() {
    this.getJcxxList();
  },
  watch:{
    "$store.state.head.skCd"() {
      //调用页面查询方法
      this.getJcxxList();
      // this.query();
    },
  }
}
</script>

<template>
  <el-container style="padding: 10px 0;">
    <el-header style="position: relative;height: 30px;">
      <safeSearch  @query="query"
                   @download="download"
               :jcxmList="jcxmList"
               :jczList="czList"
               :getCzList ="getCzList"
               :showAllStations="false"
               :show-export="true"
               :showStationSelect="true"></safeSearch>
    </el-header>
    <el-main style="height: 100%;color: whitesmoke">
      <el-table
          :data="tableData"
          style="width: 100%;padding: 10px"
          border
          height="calc(100vh - 185px)"
          max-height="calc(100vh  - 175px)"
          :row-style="tableRowClassName"
          :header-cell-style="{backgroundColor:'white',fontSize: '1.4rem',textAlign:'center',color:'#323232',
                          fontFamily:'PingFang SC',fontWeight:'bold',fontStretch:'normal',height:'3vh'}"
      >
        <el-table-column label="安全日报表" align="center">
          <template #header>
            <label style="font-size: 28px">{{tableTitle}}</label>
          </template>
            <el-table-column
                v-for="item in columns"
                :label="item.label"
                :width="item.width"
                :prop="item.prop"
                :key="item.prop"
                :align="item.align"
                header-align="center">
            </el-table-column>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<style scoped>
  /deep/.el-main {
  display: block;
  flex: 1;
  flex-basis: auto;
  overflow: auto;
  box-sizing: border-box;
  padding: 0px;
  padding-top: 20px;
  padding-bottom: 20px;
}

  /* 自定义滚动条样式 */
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 2px; /* 滚动条宽度 */
    height: 1px; /* 滚动条高度 */
  }

  /* 滚动条轨道 */
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
    background-color: #f5f5f5; /* 轨道颜色 */
  }

  /* 滚动条滑块 */
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #ccc; /* 滑块颜色 */
    border-radius: 2px; /* 滑块圆角 */
  }
</style>
